export const FRONTEND_WEBSOCKET = 'wss://gm3oqoswfc.execute-api.eu-central-1.amazonaws.com/Prod'
